const useStyles = {
  button: {
    borderRight: `0 !important`,
    alignItems: 'center',
  },
  buttonGroup: {
    borderRadius: '20px',
    gap: '2px',
    overflow: 'hidden',
  },
}

export default useStyles
